import { Model } from "../decorators/model.decorator";
import { Column } from "../decorators/column.decorator";
import { BaseModel } from "./base.model";

@Model('user', ['doLogin', 'doLogout', 'checkLogin', 'checkEmail'])
export class User extends BaseModel {
  @Column()
  id: number | undefined;
  @Column()
  username: string | undefined;
  @Column()
  email: string | undefined;
  @Column()
  password: string | undefined;
  @Column()
  name: string | undefined;
  @Column()
  persistenceToken: string | undefined;
  @Column()
  requireLogin: boolean | undefined;

  public impersonated: boolean = false

  public loggedIn(): boolean {
    return (!!this.persistenceToken && this.persistenceToken !== '')
  }

}
